import React from 'react';
import { Box, Typography } from '@mui/material';
import MarkChatUnreadOutlinedIcon from '@mui/icons-material/MarkChatUnreadOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import './TotalsCard.css';

const TotalsCard = ({ opened, closed }) => {
  const openedValue = Number.isFinite(opened) ? opened : 0;
  const closedValue = Number.isFinite(closed) ? closed : 0;
  const inAttendance = Math.max(0, openedValue - closedValue);

  return (
    <Box className="totalsCard">
      <Box className="totalsCard__item">
        <MarkChatUnreadOutlinedIcon className="totalsCard__icon" />
        <Typography className="totalsCard__value">{inAttendance}</Typography>
      </Box>
      <Box className="totalsCard__item">
        <DoneAllOutlinedIcon className="totalsCard__icon" />
        <Typography className="totalsCard__value">{closedValue}</Typography>
      </Box>
    </Box>
  );
};

export default TotalsCard;
